import common from 'store/modules/common/api'

export const api = {
  lookup: true,
  ...common.apiMethods('Suppliers')
}
